import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthContext } from '../hooks';
import OnboardingLockedPage from '../../pages/OnboardingLockedPage';

export default function CompanyOnboardingGuard({ children }) {
  const { user } = useAuthContext();
  const { pathname } = useLocation();
  const id = user?.data?.current_company;
  if (user?.data?.companies?.[id]?.status !== 'onboarding' || pathname.startsWith('/onboarding/')) {
    return <>{children}</>;
  }
  if (pathname === '/') return <Navigate to={`/onboarding/${id}`} replace />;
  return <OnboardingLockedPage companyId={id} />;
}
CompanyOnboardingGuard.propTypes = { children: PropTypes.node };
